import React, { useState, useEffect } from 'react'
import image1 from '../Assets/netaestheticspic.png'
import { useLocation } from 'react-router-dom';
function Navbar() {

  const [lastScrollY, setLastScrollY] = useState(0); // Track the last scroll position
  const [isVisible, setIsVisible] = useState(true); // Control navbar visibility
  const [visiblelinks, setvisiblelinks] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsVisible(false); // Hide the navbar
      }
      // Check if the user is scrolling towards the header (upwards)
      else if (currentScrollY < lastScrollY) {
        setIsVisible(true); // Show the navbar
      }

      // Update last scroll position
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const handleclick = () => {
    console.log("Bilal Is Here");
    setIsMenuOpen(!isMenuOpen);

  }


  return (
    <>
      <div class="container-default home-hero fixed-background-container w-container ">

        <div class="bg-gradient-blur-wrapper home-hero-1 fixed-background" style={{ transform: "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(124.783deg) skew(0deg)", transformStyle: "preserve-3d", willChange: "transform" }}>
          <div class="bg-gradient-blur-circle-3"></div>
          <div class="bg-gradient-blur-circle-2"></div>
          <div class="bg-gradient-blur-circle-1"></div>
        </div>
        <div class="bg-gradient-blur-wrapper home-hero-2 fixed-background" style={{ transform: "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(124.783deg) skew(0deg)", transformStyle: "preserve-3d", willChange: "transform" }}>
          <div class="bg-gradient-blur-circle-3"></div>
          <div class="bg-gradient-blur-circle-2 blue"></div>
          <div class="bg-gradient-blur-circle-1 purple"></div>
        </div>
      </div>
      <div className={`container-fluid mainnav ${isVisible ? 'navbar--visible' : 'navbar--hidden'} `}>

        <div className="d-flex justify-content-between align-items-center  px-4 navcon">

          <div className="titlecontainer d-flex" >
            <img className='' src={image1} alt="NetAesthetics logo link" loading="eager" />
            <a href='/' className="">NetAesthetics</a>
          </div>
          <div >
            <nav className='nav'  >
              <a className={`nav-link text-white ${location.pathname === '/' ? 'active' : ''}`} href="/" >Home</a>
              <a className={`nav-link text-white  ${location.pathname === '/about' ? 'active' : ''}`} href="/about">About Us</a>
              <a className={`nav-link text-white  ${location.pathname === '/portfolio' ? 'active' : ''}`} href="/portfolio">Portfolio</a>
              <a className={`nav-link text-white  ${location.pathname === '/blog' ? 'active' : ''}`} href="/blog">Blog</a>
              <a className={`nav-link text-white  ${location.pathname === '/contact' ? 'active' : ''}`} href="/contact">Contact Us</a>
            </nav>
          </div>
          <div  >
            <nav className={isMenuOpen ? 'nav active menu-popup' : 'd-none'}  >
              <div className='cancel-menu-icon ' onClick={handleclick}>
                <p>X</p>
              </div>
              <a className={`nav-link text-white ${location.pathname === '/' ? 'active' : ''}`} href="/" >Home</a>
              <a className={`nav-link text-white  ${location.pathname === '/about' ? 'active' : ''}`} href="/about">About Us</a>
              <a className={`nav-link text-white  ${location.pathname === '/portfolio' ? 'active' : ''}`} href="/portfolio">Portfolio</a>
              <a className={`nav-link text-white  ${location.pathname === '/blog' ? 'active' : ''}`} href="/blog">Blog</a>
              <a className={`nav-link text-white  ${location.pathname === '/contact' ? 'active' : ''}`} href="/contact">Contact Us</a>
              <div className='getstartedbutton' sty >
                <a href='/contact' className="nav-link text-white ">Get Started</a>

              </div>
            </nav>
          </div>

          <div className="getstarted  d-none d-lg-flex justify-content-end ">

            <div className='headerbutton'>
              <a href='/contact' className="nav-link text-white ">Get Started</a>

            </div>
          </div>
          <div className='rounded-circle menucontainer ' onClick={handleclick}>
            <div className='firstmenu'></div>
            <div className='secondmenu'></div>
            <div className='thirdmenu'></div>
          </div>

        </div>

      </div>


    </>
  )
}

export default Navbar